/* global $ */

setup();
document.addEventListener("remount:store-shopping", remount);

function remount() {
  setUpQuantityHandling();
  updateAddToCart();
  setUpSubmit();
}

function setup() {
  remount();
}

function adjustFormatMaxQuantity(event) {
  const formats = $(event.currentTarget);
  if (formats.length) {
    const maxOrder = formats.data("max");
    $(".js-quantity").attr("max", parseInt(maxOrder));
    if (showLimitedInventoryNotice(event)) {
      $(".js-limited-quantity").removeClass("hidden");
    } else {
      $(".js-limited-quantity").addClass("hidden");
    }
  }
}

function showLimitedInventoryNotice(event) {
  const currentMax = parseInt($(".js-quantity").attr("max"));
  const hasFormats = $(".product_format__wrapper").length > 0;
  if (!hasFormats && $(".js-inventory-notice").length === 0 && 0 < currentMax && currentMax <= 10) {
    // There are no formats, no inventory notices, and the current max is within 10.
    return false;
  }

  const formatNotice = $(event.currentTarget).parent().has(".js-inventory-notice").length;
  return !formatNotice && 0 < currentMax && currentMax <= 10;
}

// inventory control. Set Add to Cart button based on availability
function updateAddToCart() {
  $(document).on("click", ".available-formats .format", function(ev) {
    var form = $(ev.currentTarget).closest("form");
    var format = form.find(".format.selected input");
    var btn = form.find(".js-addcart");
    if (format.hasClass("js-outofstock")) {
      btn.prop("disabled", true);
    }
    else {
      btn.prop("disabled", false);
    }
  });
  $('.available-formats .product_format__wrapper:first-child .format').click();
}


function setUpQuantityHandling() {
  const $quantityInput = $(".js-quantity");

  // Update displayed quantity on input change
  $quantityInput.on("keyup input", function () {
    const $input = $(this);
    if (!$input[0].reportValidity()) {
      updateQuantityButtons($input);
      return;
    }
    let quantity = $input.val();
    $(".js-qty_to_add").text(quantity);
    updateQuantityButtons($input);
  });

  // Handle increment button
  $(".js-quantity_increment").on("click", function () {
    const $input = $quantityInput;
    const currentValue = parseInt($input.val()) || 1;
    const min = parseInt($input.attr("min")) || 1;
    const max = parseInt($input.attr("max")) || Infinity;

    if (currentValue < max) {
      $input.val(currentValue + 1).trigger("keyup");
    } else {
      $(this).prop("disabled", true);
    }
  });

  // Handle decrement button
  $(".js-quantity_decrement").on("click", function () {
    const $input = $quantityInput;
    const currentValue = parseInt($input.val()) || 1;
    const min = parseInt($input.attr("min")) || 1;

    if (currentValue > min) {
      $input.val(currentValue - 1).trigger("keyup");
    } else {
      $(this).prop("disabled", true);
    }
  });

  // Initial button state
  updateQuantityButtons($quantityInput);

  const formats = $(".available-formats .format");
  if (formats.length > 0) {
    formats.on("click", function (event) {
      // If formats are present, reset quantity to 1 on format change and update the max attribute.
      adjustFormatMaxQuantity(event);
      $quantityInput.val(1);
      $(".js-qty_to_add").text(1);
      updateQuantityButtons($quantityInput);
    });

    // Note: the trigger for the first click is in app.js (`updateAddToCart`).
  } else {
    const currentMax = parseInt($(".js-quantity").attr("max"));
    if ($(".js-inventory-notice").length === 0 && 0 < currentMax && currentMax <= 10) {
      $(".js-limited-quantity").removeClass("hidden");
    }
  }
}

function updateQuantityButtons($input) {
  const currentValue = parseInt($input.val()) || 1;
  const max = parseInt($input.attr("max")) ?? 1000;
  const min = Math.min(max, parseInt($input.attr("min")));

  if (max === 0) {
    $(".js-quantity_decrement").prop("disabled", true);
    $(".js-quantity_increment").prop("disabled", true);
    $(".js-quantity").prop("disabled", true);
    $(".js-addcart").prop("disabled", true);
  } else {
    $(".js-quantity_decrement").prop("disabled", currentValue <= min);
    $(".js-quantity_increment").prop("disabled", currentValue >= max);
    $(".js-quantity").prop("disabled", false);
    $(".js-addcart").prop("disabled", false);
  }
}

function setUpSubmit() {
  $(".js-add-to-cart-form").on("submit", function (e) {
    e.preventDefault();
    $(this).find('button[type="submit"]').prop("disabled", true);
    $(this).trigger("submit");
  });
}
